
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#B6B6B6","d":"M5.222 15.988a.57.57 0 01-.482-.213c-.092-.12-3.135-4.117-3.225-4.242-.259-.355-.299-.66-.224-.9.113-.367.83-4.363-.614-8.446-.155-.437 1.443-.843 1.942.38.342.84.774 3.523 1.171 3.707.307.141 1.61-.27 3.423-2.12L10.856.43c.345-.353.912-.329 1.265.052.354.382.36.98.014 1.331L8.956 5.063c-.31.316-.371.575-.204.761.149.167.286.158.605-.11l4.028-3.654c.365-.331.93-.275 1.263.126.335.401.31.996-.056 1.326l-3.83 3.475c-.337.306-.482.544-.287.748.117.123.32.028.486-.085l3.825-2.903c.393-.297.954-.191 1.257.236.301.428.23 1.013-.163 1.311L12.356 8.97c-.519.392-.67.62-.512.844.16.229.348.138.494.039l3.097-2.12c.369-.252.876-.132 1.133.269.258.399.168.928-.2 1.178l-3.371 2.307v.001h-.002l-2.022 1.384a9.853 9.853 0 00-1.044.868c-1.894 1.84-4.189 2.218-4.707 2.248z"}})])
          )
        }
      }
    